<svc-dialog
  #dialog
  [fullscreen]="['XS', 'SM']"
>
  <div
    svc-dialog-title
    class="flex gap-2 items-center text-default"
  >
    <mat-icon
      svgIcon="heroicons_solid:printer"
      class="icon-size-6 text-current"
    />
    <div class="flex-auto">
      {{ 'Imprimir' | transloco }}
    </div>
  </div>
  <div
    svc-dialog-content
    class="p-3"
  >
    <div
      class="printer-container flex flex-col"
      [class.hidden]="isLoading"
    >
      @for (option of data?.options ?? []; track $index; let optionIndex = $index) {
        @if (option.show ?? true) {
          <div class="printer-option flex flex-col">
            <ng-container
              [ngTemplateOutlet]="optionTemplate"
              [ngTemplateOutletContext]="{ option, disabled: option.disabled ?? false, fromAddtional: false }"
            />
            @for (childOption of option.options ?? []; track $index) {
              @if (childOption.show ?? true) {
                <div class="printer-option flex flex-col gap-2 pt-2 pl-9">
                  <ng-container
                    [ngTemplateOutlet]="optionTemplate"
                    [ngTemplateOutletContext]="{ option: childOption, disabled: option.disabled || !option.selected || (childOption.disabled ?? false), fromAddtional: false }"
                  />
                </div>
              }
            }
          </div>
        }
      }
      @if (data?.additional?.options?.length) {
        <div class="border-t mt-1">
          <div class="flex items-center pt-2 pb-1 text-sm">
            <div class="text-current font-semibold">
              {{ data?.additional.title ?? ('Itens adicionais' | transloco) }}
            </div>
            <button
              type="button"
              class="flex text-default opacity-60 p-1 bg-transparent border-0"
              matTooltipPosition="above"
              [matTooltip]="data?.additional?.titleTip ?? ('Os itens selecionados a seguir serão impressos novamente em uma escala ampliada ao final.' | transloco)"
              #infoTip="matTooltip"
              (click)="infoTip.toggle()"
            >
              <mat-icon
                class="icon-size-4 text-current"
                svgIcon="fontawesome_solid:circle-info"
              />
            </button>
          </div>
          @for (option of data?.additional?.options ?? []; track $index; let optionIndex = $index) {
            @if (option.show ?? true) {
              <div class="printer-option flex flex-col">
                <ng-container
                  [ngTemplateOutlet]="optionTemplate"
                  [ngTemplateOutletContext]="{ option, disabled: option.disabled ?? false, fromAddtional: true }"
                />
                @for (childOption of option.options ?? []; track $index) {
                  <div class="printer-option flex flex-col gap-2 pt-2 pl-9">
                    @if (childOption.show ?? true) {
                      <ng-container
                        [ngTemplateOutlet]="optionTemplate"
                        [ngTemplateOutletContext]="{ option: childOption, disabled: option.disabled || !option.selected || (childOption.disabled ?? false), fromAddtional: true }"
                      />
                    }
                  </div>
                }
              </div>
            }
          }
        </div>
      }
    </div>
    @if (isLoading) {
      <div class="flex items-center justify-center py-50">
        <mat-spinner diameter="30" />
      </div>
    }
  </div>
  <div
    svc-dialog-actions
    class="flex gap-2 justify-end"
  >
    <button
      svc-outlined-btn
      type="button"
      (click)="!isLoading && dialog?.closeDialog()"
      [disabled]="isLoading"
    >
      {{ 'Fechar' | transloco }}
    </button>
    <button
      svc-filled-btn
      type="button"
      [disabled]="isLoading || !someOptionSeleted"
      [class.force-enabled]="!isLoading && someOptionSeleted"
      (click)="!isLoading && someOptionSeleted && print()"
      cdkFocusInitial
    >
      {{ 'Imprimir' | transloco }}
    </button>
  </div>
</svc-dialog>

<ng-template
  #optionTemplate
  let-option="option"
  let-disabled="disabled"
  let-fromAddtional="fromAddtional"
>
  <div class="flex items-center gap-2">
    <div>
      <mat-checkbox
        class="flex -mr-2"
        [checked]="option.selected ?? false"
        (change)="!disabled && changeOptionSelected(option)"
        [disabled]="disabled"
      />
    </div>
    @if (option.miniature && option.element) {
      <div
        #elementContainer
        [ngClass]="{ 'cursor-pointer': !disabled, 'opacity-50': disabled }"
        (click)="!disabled && changeOptionSelected(option, fromAddtional)"
      >
        <svc-printer-miniature
          [option]="option"
          [printAreaWidth]="data.printAreaWidth"
        />
      </div>
    }
    <div
      class="flex-auto text-sm font-semibold text-current"
      [ngClass]="{ 'cursor-pointer': !disabled, 'opacity-50': disabled }"
      (click)="!disabled && changeOptionSelected(option, fromAddtional)"
    >
      {{ option.name }}
    </div>
  </div>
  @if (option.selected && option.elements?.length && option.areAllImageElements) {
    <svc-printer-img-carousel
      class="w-full max-w-80 mt-2"
      [option]="option"
    />
  }
</ng-template>
